<div class="skl-sync-item-logs" aria-busy="true" aria-label="Loading sync log details">
  <div class="skl-header">
    <div>
      <app-skeleton width="240px" height="22px" borderRadius="4px" marginBottom="10px"></app-skeleton>
      <app-skeleton width="220px" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
    </div>
    <app-skeleton width="150px" height="38px" borderRadius="4px" marginBottom="0"></app-skeleton>
  </div>

  <div class="skl-card">
    <div class="skl-card__header">
      <app-skeleton width="110px" height="16px" borderRadius="4px" marginBottom="0"></app-skeleton>
    </div>
    <div class="skl-card__body skl-summary-grid">
      @for (stat of summaryStats; track stat) {
        <div>
          <app-skeleton width="70%" height="13px" borderRadius="3px" marginBottom="8px"></app-skeleton>
          <app-skeleton width="52%" height="16px" borderRadius="3px" marginBottom="0"></app-skeleton>
        </div>
      }
    </div>
  </div>

  <app-sync-item-logs-table-skeleton></app-sync-item-logs-table-skeleton>
</div>